import React, { useState } from 'react';

import cert1 from './assets/certificates/1714421081529.jpg';
import cert2 from './assets/certificates/1715762548510.jpg';
import cert3 from './assets/certificates/1716638659919.jpg';
import cert4 from './assets/certificates/1720360566942.jpg';
import cert5 from './assets/certificates/canvas.png';
import cert6 from './assets/certificates/CERTIFICATE_LANDING_PAGE~PMMDU432HJ9Q.jpeg';

const certificates = [
  { id: 1, title: 'Frontend Developer (React)', issuer: 'HackerRank', image: cert1, category: 'Development' },
  { id: 2, title: 'HacknChill 2024', issuer: 'GDSC ADGIPS', image: cert2, category: 'Hackathon' },
  { id: 3, title: 'Foundations of Cybersecurity', issuer: 'Google · Coursera', image: cert3, category: 'Cybersecurity' },
  { id: 4, title: 'Ethical Hacking & Cybersecurity', issuer: 'HackerX', image: cert4, category: 'Cybersecurity' },
  { id: 5, title: 'Problem Solving (Basic)', issuer: 'HackerRank', image: cert5, category: 'Development' },
  { id: 6, title: 'Automate Cybersecurity Tasks with Python', issuer: 'Google · Coursera', image: cert6, category: 'Cybersecurity' },
];

const CertificateModal = ({ cert, onClose }) => {
  if (!cert) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80" onClick={onClose}>
      <div className="relative max-w-4xl w-full rounded-2xl border border-[var(--line)] bg-[var(--bg)] overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-3 right-4 text-[var(--ink)] bg-transparent border-0">Close</button>
        <img src={cert.image} alt={cert.title} className="w-full h-auto" />
        <div className="p-5 border-t border-[var(--line)] flex items-center justify-between gap-4">
          <div>
            <p className="text-[var(--ink)]">{cert.title}</p>
            <p className="text-sm text-[var(--muted)]">{cert.issuer}</p>
          </div>
          <span className="text-sm text-[var(--muted)]">{cert.category}</span>
        </div>
      </div>
    </div>
  );
};

const MyAchievements = () => {
  const [selectedCert, setSelectedCert] = useState(null);
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Development', 'Cybersecurity', 'Hackathon'];
  const filteredCerts = filter === 'All' ? certificates : certificates.filter((cert) => cert.category === filter);

  return (
    <section id="achievements" className="section border-b border-[var(--line)]">
      <div className="wrap">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <p className="t-kicker mb-4">Certificates</p>
            <h2 className="t-display text-5xl md:text-6xl">Proof of work.</h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setFilter(cat)}
                className={`chip bg-transparent cursor-pointer ${filter === cat ? 'border-[var(--signal)] text-[var(--ink)]' : ''}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {filteredCerts.map((cert) => (
            <button
              key={cert.id}
              onClick={() => setSelectedCert(cert)}
              className="text-left rounded-2xl border border-[var(--line)] bg-[var(--bg-2)] p-5 flex items-center justify-between gap-6 cursor-pointer"
            >
              <div>
                <p className="text-[var(--ink)] mb-1">{cert.title}</p>
                <p className="text-sm text-[var(--muted)]">{cert.issuer}</p>
              </div>
              <span className="text-sm text-[var(--signal)] shrink-0">View</span>
            </button>
          ))}
        </div>
      </div>

      {selectedCert && (
        <CertificateModal cert={selectedCert} onClose={() => setSelectedCert(null)} />
      )}
    </section>
  );
};

export default MyAchievements;
